import {Component, effect, inject, input, OnInit, WritableSignal} from '@angular/core'
import {MatFormField, MatInput, MatSuffix} from '@angular/material/input'
import {FormsModule} from '@angular/forms'
import {Configuration} from '../../../services/configuration'

@Component({
  selector: 'spb-interest-input',
  imports: [
    MatFormField,
    MatInput,
    FormsModule,
    MatSuffix
  ],
  templateUrl: './interest-input.html',
  styleUrls: ['../../table-inputs.scss']
})
export class InterestInput implements OnInit {
  /**
   * We need to wrap the signal in an object since
   * it cannot be understood otherwise and I do not
   * understand why you cannot have signals as raw inputs.
   */
  /* v8 ignore next */
  public value = input.required<{ p: WritableSignal<number> }>()

  /* v8 ignore next */
  public showSuffix = input<boolean>(false)

  public service = inject(Configuration)

  private original: number | null = null

  private readonly id = crypto.randomUUID()

  constructor() {
    effect(() => {
      if (this.original === this.value().p()) {
        this.service.changes.update(changes =>
          changes.filter(([id]) => id !== this.id))
      }

      if (this.original !== this.value().p()) {
        this.service.changes.update(changes => {
          return changes
            .filter((id) => id[0] !== this.id)
            .concat([[this.id, this.original!]])
        })
      }
    })
  }

  public ngOnInit(): void {
    this.original = this.value().p()
    this.service.saved.subscribe(() => this.original = this.value().p())
  }
}
